$('.js-closeCookie').on('mouseover', () => $('.cookie').addClass('is-hovered'));
$('.js-closeCookie').on('mouseout', () => $('.cookie').removeClass('is-hovered'));
$('.js-closeCookie').on('click', () => $('.cookie').fadeOut());
